import { useEffect } from "react";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import "@/App.css";
import { setLenis } from "@/lib/scroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Impact } from "@/components/site/Impact";
import { Services } from "@/components/site/Services";
import { Audiences } from "@/components/site/Audiences";
import { IdeaCallout } from "@/components/site/IdeaCallout";
import { Process } from "@/components/site/Process";
import { Differentials } from "@/components/site/Differentials";
import { Portfolio } from "@/components/site/Portfolio";
import { About } from "@/components/site/About";
import { Conversion } from "@/components/site/Conversion";
import { Contact } from "@/components/site/Contact";
import { FAQ } from "@/components/site/FAQ";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf = requestAnimationFrame(function loop(t) {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    });
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);
};

function App() {
  useLenis();
  return (
    <MotionConfig reducedMotion="user">
      <div className="grain relative min-h-screen overflow-x-clip bg-ws-bg">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Impact />
          <Services />
          <Audiences />
          <IdeaCallout />
          <Process />
          <Differentials />
          <Portfolio />
          <About />
          <Conversion />
          <Contact />
          <FAQ />
        </main>
        <Footer />
        <WhatsAppFloat />
      </div>
    </MotionConfig>
  );
}

export default App;
